import { render, staticRenderFns } from "./ErrorSSOLanding.vue?vue&type=template&id=5f7974b4"
import script from "./ErrorSSOLanding.vue?vue&type=script&lang=js"
export * from "./ErrorSSOLanding.vue?vue&type=script&lang=js"
import style0 from "./ErrorSSOLanding.vue?vue&type=style&index=0&id=5f7974b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports